import getItemMenu from "./getItemMenu"
import moment from 'moment'

const emp = {
    GEO: 'GEOMACO',
    ELS: 'EL SOL',
    SUP: 'SUPERMAT',
    SAS: 'SUPERMAT SAS',
    ELA: 'SUPERMAT',
    HIP: 'HIPERCAT',
    SIST: 'SISTEMAS',
    DIR: 'DASHBOARD DIRECCION',
    CDIG: 'SUPERMAT'
}

const lastProps = {
    nom: '',
    fch: null
}

export { lastProps }

export default (nom, fch = moment().format('YYYY-MM-DD')) => {
    const item = getItemMenu()
    const key = item ? item.IMenuEmp : ''
    const menu = item ? item.MenuNom : ''
    const id = item ? item.IMenuId: ''

    lastProps.nom = nom
    lastProps.fch = fch

    // If fch is not provided or empty, use current date/time for the filename
    const dateStr = (!fch || (typeof fch === 'object' && !fch.dsd)) 
        ? moment().format('YYYYMMDD_HHmm') 
        : (typeof fch === 'string' ? fch : `${fch.dsd}_a_${fch.hst}`);

    const safeNom = nom.replace(/[^a-z0-9]/gi, '_').toLowerCase();
    const prefix = item ? (emp[key] || key || 'TuFila') + '_' + menu.replace(/[^a-z0-9]/gi, '_') : 'TuFila';

    return `${prefix}_${safeNom}_${dateStr}${id ? '_ID' + id : ''}`;
}